/* eslint-disable react/prop-types */
import React from 'react';
import { cn, getText } from '../../../helpers';
import { ReactComponent as CloseIcon } from '../../../assets/svg/icons/close.svg';
import Button from '../../_common/button';
import pushGA4AnnouncementEvent from '../../../utilities/ga4-announcement-events';
import { convertUrlToCurrentLanguage } from '../../../utilities/announcementsUtilites';

const defaultNotification: Announcement = { KeyMarketplaceAnnouncements: '', Title: '', Description: '', Category: '', CategoryColor: '', PublishedAt: '', CTALabel: '', CTAUrl: '', ShowRedLine: false, IsInternalUrl: false };

const AnnouncementCard: React.FC<AnnouncementCardProps> = ({
    notification = defaultNotification,
    onDismiss = () => {},
    isNew = false,
    sourceLocation = 'panel',
    useBackendHighlight = true
}) => {
    const ac = 'announcement-card';
    const langCode = getText('langCode');
    const isHighlighted = isNew || (useBackendHighlight && notification.ShowRedLine);

    const formatDate = (isoDate: string): string => {
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
    };

    const getFormattedDescription = (description: string) => {
        if (!description) return '';

        return description.length > 250
            ? `${description.substring(0, 250).trim()}...`
            : description;
    };

    return (
        <li key={notification.KeyMarketplaceAnnouncements} className={cn(`${ac}__item`, isHighlighted && `${ac}__item--new`)}>
            <>
                <button
                    type="button"
                    className={`${ac}__close-btn`}
                    aria-label={`Dismiss ${notification.Title}`}
                    onClick={() => onDismiss(notification.KeyMarketplaceAnnouncements)}
                >
                    <CloseIcon />
                </button>

                <div className={`${ac}__item-meta`}>
                    <span className={`${ac}__tag`} style={{ color: notification.CategoryColor }}>
                        {notification.Category}
                    </span>
                    <span className={`${ac}__date`}>{formatDate(notification.PublishedAt)}</span>
                </div>

                <h3 className={`${ac}__item-title`}>{notification.Title}</h3>
                <p className={`${ac}__item-desc`}>{getFormattedDescription(notification.Description)}</p>
                <Button
                    text={notification.CTALabel}
                    theme="secondary"
                    type="button"
                    className={`${ac}__cta__button`}
                    onClick={e => {
                        pushGA4AnnouncementEvent('announcement_cta_click', {
                            announcementId: notification.KeyMarketplaceAnnouncements,
                            announcementTitle: notification.Title,
                            announcementCategory: notification.Category,
                            isHighlighted,
                            sourceLocation
                        });
                        const destinationUrl = notification.IsInternalUrl ? `/${langCode}${convertUrlToCurrentLanguage(notification.CTAUrl)}` : notification.CTAUrl;

                        window.open(destinationUrl, '_blank', 'noopener,noreferrer');

                        (e.currentTarget as HTMLButtonElement).blur();
                    }}
                />
            </>
        </li>
    );
};
export default React.memo(AnnouncementCard);
